import { ContactType } from '@api/generated/graphql';
import { IconNameType } from '@servicetitan/design-system';

const getContactMethodIconName = (type: ContactType): IconNameType => {
  switch (type) {
    case ContactType.Phone:
      return 'phone';
    case ContactType.MobilePhone:
      return 'phone_iphone';
    case ContactType.Email:
      return 'email';
    case ContactType.Fax:
      return 'print';
    default:
      return 'help';
  }
};

export default getContactMethodIconName;
